import type { CourseDetailSectionsItemLecturesItem } from './courseDetailSectionsItemLecturesItem';

export type CourseDetailSectionsItem = {
  id: number;
  lectures: CourseDetailSectionsItemLecturesItem[];
  title: string;
};
